const useGenericOptions = genericOptions => {
  return typeof genericOptions !== undefined && genericOptions.length > 0
}

const extractGenericOptions = genericOptions => {
  if (typeof genericOptions === 'undefined') return []
  const extractedGenericOptions = genericOptions.map(gOption => {
    return gOption.genericName !== '' && gOption.genericName
  })
  const extractedPackageNames = genericOptions.reduce((filtered, gOption) => {
    gOption.packageName && !filtered.includes(gOption.packageName) && filtered.push(gOption.packageName)
    return filtered
  }, [])

  return extractedPackageNames.every(genericNamePackage => {
    return extractedGenericOptions.includes(genericNamePackage)
  })
    ? extractedGenericOptions
    : [].concat(extractedPackageNames, extractedGenericOptions)
}

export { useGenericOptions, extractGenericOptions }
